import { useCallback } from 'react';

import { trackingKeys } from '../../tracking';
import { SAFE_DEAL_CLICK_SOURCE } from '../../constants';

export type TrackEventWithA2BExtraParams = (
  key: string,
  extraParams?: Record<string, string | number | null>,
) => void;

const useSafeDealAdTracking = (trackEvent: TrackEventWithA2BExtraParams) => {
  const {
    safeDealInfoIconClick,
    safeDealInfoboxOpened,
    safeDealInfoboxCloseClick,
    safeDealTermsAndConditionClick,
  } = trackingKeys.events;

  const trackCloseModalClick = useCallback(
    () => trackEvent(safeDealInfoboxCloseClick),
    [safeDealInfoboxCloseClick, trackEvent],
  );

  const trackOpenModalClick = useCallback(
    (isOpenedFromInfoIconClick: boolean) => {
      const touchPointButton = isOpenedFromInfoIconClick
        ? SAFE_DEAL_CLICK_SOURCE.INFO_ICON_BUTTON
        : SAFE_DEAL_CLICK_SOURCE.NULL;
      trackEvent(safeDealInfoboxOpened, { touch_point_button: touchPointButton });
    },
    [safeDealInfoboxOpened, trackEvent],
  );

  const trackInfoIconClick = useCallback(
    () => trackEvent(safeDealInfoIconClick, { touch_point_button: SAFE_DEAL_CLICK_SOURCE.NULL }),
    [safeDealInfoIconClick, trackEvent],
  );

  const trackTermsAndConditionClick = useCallback(
    (sourceClick: string = SAFE_DEAL_CLICK_SOURCE.NULL) => {
      trackEvent(safeDealTermsAndConditionClick, { touch_point_button: sourceClick });
    },
    [safeDealTermsAndConditionClick, trackEvent],
  );

  return {
    trackCloseModalClick,
    trackOpenModalClick,
    trackTermsAndConditionClick,
    trackInfoIconClick,
  };
};

export default useSafeDealAdTracking;
